import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { lighten, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { clearSummeryCourses } from '../../actions'
import Link from '@material-ui/core/Link'

import MaterialTable from 'material-table'

import { connect } from 'react-redux'

import FullScreenDialog from './FullScreenDialog'

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein }
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  title: {
    flex: '1 1 100%'
  }
}))

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles()
  const { numSelected } = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color='inherit'
          variant='subtitle1'
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant='h6' id='tableTitle'>
          Courses
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title='Delete'>
          <IconButton aria-label='delete'>{/* <DeleteIcon /> */}</IconButton>
        </Tooltip>
      ) : (
        <Tooltip title='Filter list'>
          <IconButton aria-label='filter list'>
            {/* <FilterListIcon /> */}
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  Loading: {
    marginTop: '-41px'
  }
}))

const CourseTable = (props) => {
  const { data, selectedCoursesList, tableCourses } = props

  const classes = useStyles()
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')

  const [page, setPage] = React.useState(0)
  const [dense, setDense] = React.useState(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)

  const [open, setOpen] = React.useState(false)
  const [dialogTitle, setDialogTitle] = React.useState('')
  const [dialogText, setDialogText] = React.useState('')

  const [fullPageModel, setFullPageModel] = React.useState(false)

  const [selectedCourseModel, setSelectedCourseModel] = React.useState('')

  let [selected, setSelected] = React.useState([])

  let subAccountIds = data.selectedSubAccount.data.map((terms) => terms.id)

  let termIds = data.selectedTerms.data.map((terms) => terms.id)

  let [realTimeSelection, setRealTimeSelection] = React.useState([])

  const [rows, setRows] = React.useState([])

  let summeryCourses = props.data.summery.courses.filter(
    (rows) => subAccountIds.indexOf(rows.account_id) != -1
  )

  if (termIds.length != 0) {
    summeryCourses = summeryCourses.filter(
      (rows) => termIds.indexOf(rows.enrollment_term_id) != -1
    )
  }

  let selectedCourseIds = summeryCourses.map((course) => course.id)

  let selectedCoursesSisID = summeryCourses.map(
    (course) => course.sis_course_id
  )

  selected = selectedCourseIds

  useEffect(() => {
    let letRows = tableCourses.data.filter(
      (rows) =>
        subAccountIds.indexOf(rows.account_id) != -1 &&
        rows.sis_course_id !== null
    )

    if (termIds.length != 0) {
      letRows = rows.filter(
        (rows) => termIds.indexOf(rows.enrollment_term_id) != -1
      )
    }

    // selectedCoursesList.map(course => course.sis_course_id).includes(rowData.sis_course_id)
    // monday check here

    letRows = letRows.map((data) => {
      let isChecked = selectedCoursesList
        .map((course) => course.sis_course_id)
        .includes(data.sis_course_id)

      return { ...data, tableData: { ...data.tableData, checked: isChecked } }
    })

    setRows(letRows)
  }, [tableCourses, selectedCoursesList, termIds.length])

  useEffect(() => {
    setRealTimeSelection(
      selectedCoursesList.map((course) => course.sis_course_id)
    )
  }, [selectedCoursesList])

  useEffect(() => {
    let updateCourses = []

    //if(selected.length != 0){
    for (let i = 0; i < props.data.summery.courses.length; i++) {
      if (selectedCourseIds.includes(props.data.summery.courses[i].id)) {
        //props.data.summery.courses.splice(i, 1);

        updateCourses.push(props.data.summery.courses[i])
      }
    }

    props.clearSummeryCourses(updateCourses)
  }, [subAccountIds.length, termIds.length])

  let setupProgress = data.setupProgress

  const getCampusName = (SisID) => {
    if (SisID === null) {
      return 'Manually Created'
    }

    let name = SisID.split('-')[1]

    return name
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'

    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleClick = (rows, event) => {
    let coursePush = []
    let newSelecteds = []

    if (rows.length) {
      newSelecteds = rows.map((n) => n.id)

      rows.map((row) => {
        coursePush.push({
          id: row.id,
          account_id: row.account_id,
          name: row.name,
          sis_course_id: row.sis_course_id,
          enrollment_term_id: row.enrollment_term_id
        })
      })
    } else {
    }

    setSelected(newSelecteds)

    props.clearSummeryCourses(coursePush)

    if (newSelecteds.includes(event.id)) {
      setSelectedCourseModel(event)
      setFullPageModel(true)
    } else {
      setFullPageModel(false)
      setSelectedCourseModel('')
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangeDense = (event) => {
    setDense(event.target.checked)
  }

  const isSelected = (name) => selected.indexOf(name) !== -1

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

  const PAGE_OPTIONS = process.env.REACT_APP_PAGE_OPTIONS

  const getTermName = (termID) => {
    return data.selectedTerms.data.filter((terms) => terms.id == termID)[0].name
  }

  const headCells = [
    {
      field: 'sis_course_id',
      numeric: true,
      disablePadding: false,
      title: 'Course ID',

      render: (row) => (
        <Link
          href='#'
          onClick={() =>
            window.open(
              process.env.REACT_APP_CANVAS_DOMAIN + 'courses/' + row.id,
              '_blank'
            )
          }
        >
          {row.sis_course_id === null ? row.id : row.sis_course_id}
        </Link>
      ),
      headerStyle: {
        color: '#015548'
      }
    },

    {
      field: 'enrollment_term_id',
      numeric: true,
      disablePadding: false,
      title: ' Term',
      render: (rowData) => rowData.term.name,
      headerStyle: {
        color: '#015548'
      }
    },
    {
      field: 'campus',
      numeric: false,
      disablePadding: false,
      title: 'Campus',
      headerStyle: {
        color: '#015548'
      }
    },

    {
      field: 'name',
      numeric: false,
      disablePadding: false,
      title: 'Course Name',
      headerStyle: {
        color: '#015548'
      }
    }
  ]

  return (
    <div>
      <Paper>
        <MaterialTable
          title='Courses'
          isLoading={
            subAccountIds.length !== 0 && data.courses.loading === true
          }
          columns={headCells}
          data={rows}
          options={{
            showSelectAllCheckbox: false,
            search: true,
            selection: true,
            pageSize: 25,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [25, 50, 100], //PAGE_OPTIONS.split(',')
            // filtering: true
            selectionProps: (rowData) => {}
          }}
          localization={{
            body: {
              emptyDataSourceMessage:
                'Please select programme and correct term.'
            }
          }}
          onSelectionChange={handleClick}
        />
      </Paper>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {' '}
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <FullScreenDialog
        selectedCourse={selectedCourseModel}
        fullPageModel={fullPageModel}
        setFullPageModel={setFullPageModel}
      />
    </div>
  )
}

// }

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin,
    selectedCoursesList: state.CourseLevelAdmin.summery.courses,
    tableCourses: state.CourseLevelAdmin.courses
  }
}

export default connect(mapStateToProps, { clearSummeryCourses })(CourseTable)
